export const ICD10Title = "ADD ICD 10 CODES:";

export const ICD10Text =
  "Please add ICD 10 codes by searching and adding codes to the below grid.";

  export enum ICD10CodeType {
    PRIMARY = 1,
    SECONDARY = 2,
  }

  //Present in allpatient records file
  export interface InfoTable {
    diagnosisCode: string;
    diagnosisCodeDescription: string;
    diagnosisTypeId: number;
    diagnosisType: string;
    icdDiagnosisCodeId: number | null;
  }

  // Present in master.ts moved in this file as of now
  export interface DiseaseType {
    icdCode: string;
    icdDescription: string;
    icdDiagnosisCodeId: number;
  }
  
  export interface IcdDiseaseType {
    diagnosisCode: string;
    diagnosisCodeDescription: string;
    icdDiagnosisCodeId: number;
  }

  export interface IcdCodeType {
    diagnosisType: string;
    diagnosisTypeId: number;
  }